import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment as env } from '@environments/environment';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';
import { ActivatedRoute, Params } from '@angular/router';

interface vipPlusInterface {
	image: string;
	description: string;
}

interface customerFeedback {
	id: number;
	image: string;
	mobileImage: string;
	feedback: string;
	audioSrc: string;
}

@Component({
	selector: 'app-vip-plus',
	templateUrl: './vip-plus.component.html',
	styleUrls: ['./vip-plus.component.scss'],
})
export class VipPlusComponent implements OnInit {
	constructor(
		public locale: LocaleService,
		public viewport: ViewportService,
		private deviceDetectorService: DeviceDetectorService,
		private route: ActivatedRoute
	) {}
	adLink: string;
	@ViewChildren('audios') audioPlayers: QueryList<any>;

	happyCustomerData: customerFeedback[] = [
		{
			id: 1,
			image: 'assets/images/vip-plus/customer-feedback-img2.png',
			mobileImage: 'assets/images/vip-plus/customer-feedback-img2mob.png',
			feedback:
				'ڕیكلامێكی زۆر باش بوو وە لە ماوەی 2 رۆژ توانیم بیفرۆشم لە بازار پارەكی زۆر كەمكتریان پێ دەدا بەلام لە رێگەی ئێوەوە توانیم یەكسەر بیفرۆشم بە نرخێكی زۆر باش',
			audioSrc: 'https://api-secure.kurdshopping.net/public/vipPlusAudio/jeep.mp3',
		},
		{
			id: 2,
			image: 'assets/images/vip-plus/customer-feedback-img3.png',
			mobileImage: 'assets/images/vip-plus/customer-feedback-img3mob.png',

			feedback: 'بصراحە إعلان جید جدا كلامكم صح بأقل وقت بیعت السیارە  بسعر مناسب ماشالله هوایە اشخاص شایفت إعلانی و هوایە ارقام منكل العراق اتصلنی ',
			audioSrc: 'https://api-secure.kurdshopping.net/public/vipPlusAudio/mg.mp3',
		},
		{
			id: 3,
			image: 'assets/images/vip-plus/customer-feedback-img4.png',
			mobileImage: 'assets/images/vip-plus/customer-feedback-img4mob.png',
			feedback:
				'سەرەتا كە بینیم ریكلامی ڤی ئای پلەس ئەو نرخەی هەیە وام هەست كرد زۆرە بەلام دواتر كە زانیم گەرەنتی سەد لە سەدی لەگەلە وە دەتوانم بیفرۆشم یەكسەر كردم و وە توانیم لە كەمترین ماوە بیفرۆشم ',
			audioSrc: 'https://api-secure.kurdshopping.net/public/vipPlusAudio/prado.mp3',
		},
	];

	vipPlusFeatures: vipPlusInterface[] = [
		{
			image: 'assets/images/vip-plus/1.png',
			description: this.locale.translations['n707'],
		},
		{
			image: 'assets/images/vip-plus/2.png',
			description: this.locale.translations['n717'],
		},
		{
			image: 'assets/images/vip-plus/3.png',
			description: this.locale.translations['n719'],
		},
		{
			image: 'assets/images/vip-plus/4.png',
			description: this.locale.translations['n718'],
		},
		{
			image: 'assets/images/vip-plus/5.png',
			description: this.locale.translations['n720'],
		},
		{
			image: 'assets/images/vip-plus/6.png',
			description: this.locale.translations['n721'],
		},
	];

	stopOtherAudios(currentAudio: HTMLAudioElement): void {
		this.audioPlayers.forEach((audio: ElementRef<HTMLAudioElement>) => {
			if (audio.nativeElement !== currentAudio) {
				audio.nativeElement.pause();
			}
		});
	}

	onOpenWhatsapp() {
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';
		let templateMessage = this.adLink
			? encodeURIComponent(this.locale.translations['n732']) + '%0a' + encodeURIComponent(this.adLink)
			: encodeURIComponent(this.locale.translations['n732']);

		window.open(`${env.WHATSAPP.callForDetails}${+964}${7512347071}&text=${templateMessage}`, targetDisplay);
	}

	onCallCustomerCare() {
		window.location.href = 'tel:' + `07512347071`;
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((params: Params) => {
			if (params['adLink']) {
				this.adLink = params['adLink'];
			}
		});
	}
}
